import { useAtom } from 'jotai';

import { useAccountInfo } from '@consumer-frontend/nc-api';
import {
  currencyString,
  formatDate,
  PaymentDetailsT,
} from '@consumer-frontend/nc-utils';

import { accountIdAtom } from '../../store';
import { NcPaymentAccountLabel } from '../NcPaymentMethod';
import { NcReviewFields, NcReviewFieldT } from '../NcReviewFields';

export type NcReviewPaymentFieldsT = React.FC<PaymentDetailsT>;

export const NcReviewPaymentFields: NcReviewPaymentFieldsT = ({
  accountLast4,
  paymentAmount,
  paymentDate,
  paymentMethod,
  paymentOwner,
  paymentSource,
  productTypeDisplay,
  routingLast4,
}) => {
  const [accountId] = useAtom(accountIdAtom);
  const { accountInfo: {
    firstName,
    lastName,
    loanNumber,
  } = {} } = useAccountInfo(accountId);

  const paymentFromContent = (
    <>
      {paymentSource}

      <NcPaymentAccountLabel
        accountLast4={accountLast4}
        paymentType={paymentMethod}
        routingLast4={routingLast4}
      />
    </>
  );

  const paymentFields: NcReviewFieldT[] = [
    {
      chromaticIgnore: true,
      label: 'Payment Date',
      value: formatDate(paymentDate),
    },
    { label: 'Payment Amount', value: `${currencyString(paymentAmount)}` },
    { label: 'Payment To', value: paymentOwner },
    { label: 'Payment From', value: paymentFromContent },
    { label: 'Name', value: `${firstName} ${lastName}` },
    { label: `${productTypeDisplay === 'Line of Credit' ? productTypeDisplay : 'Loan'} #`, value: loanNumber },
  ];

  return <NcReviewFields fields={paymentFields} />;
};
